import { FC, useState, useMemo } from 'react';
import { Loader } from '@new/common/ui/Loader/Loader';
import { WeeklyAvailabilityCalendar } from '../components/WeeklyAvailabilityCalendar/WeeklyAvailabilityCalendar';
import { AvailabilitySlotList } from '../components/AvailabilitySlotList/AvailabilitySlotList';
import { useGetAvailabilitySlotsQuery } from '@teachur/http-client';
import { getStartOfWeek, getEndOfWeek } from '../lib/helpers';

export const InstructorSchedulePage: FC = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const weekStart = useMemo(() => getStartOfWeek(selectedDate), [selectedDate]);
  const weekEnd = useMemo(() => getEndOfWeek(selectedDate), [selectedDate]);

  const {
    data: availabilitySlots,
    isLoading,
    isError,
  } = useGetAvailabilitySlotsQuery({
    startDate: weekStart.toISOString(),
    endDate: weekEnd.toISOString(),
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-neutral-600 mb-4">Failed to load availability slots</p>
          <button
            onClick={() => window.location.reload()}
            className="text-(--secondary-S800) hover:text-(--secondary-S900) font-medium"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-(--bg-blue)">
      <div className="flex flex-col gap-8 px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col gap-2">
          <h2 className="[font-size:var(--fs-h2)] [font-family:var(--font-montserrat)]! font-bold! text-(--neutral-black-NB1000)! m-0!">
            Availability Schedule
          </h2>
          <p className="[font-size:var(--fs-p2)] text-(--neutral-black-NB900)! m-0!">
            Manage your availability by selecting time slots on the calendar below
          </p>
        </div>

        <div className="flex flex-col gap-6">
          <WeeklyAvailabilityCalendar
            availabilitySlots={availabilitySlots || []}
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
          />

          <AvailabilitySlotList slots={availabilitySlots || []} />
        </div>
      </div>
    </div>
  );
};
